import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { vacationsApi } from 'app/services/edpApiV1/vacations';
import { reportsApi, ReportsResponse } from 'app/services/edpApiV1/reports';

const initialState = {
  type: '',
  data: [],
} as ReportsResponse;

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        reportsApi.endpoints.reports.matchFulfilled,
        (state, { payload }: PayloadAction<ReportsResponse>) => payload,
      )
      .addMatcher(vacationsApi.endpoints.vacations.matchRejected, () => initialState);
  },
});

const reports = (state: RootState) => state.entities.reports;
const getReports = createSelector(reports, state => state);

export const selectors = { getReports };
export const actions = reportsSlice.actions;
export const reducer = reportsSlice.reducer;
